// ARQUIVO GERADO AUTOMATICAMENTE por scripts/gen-version.js — NÃO EDITAR À MÃO.
// Regerado a cada build/serve pelos hooks pre* do package.json.
export const buildInfo = {
  version: '10.0.0',
  commit: '30bbc815',
  branch: '3.8',
  buildDate: '2026-08-06T14:46:44.195Z',
};
